import React from 'react';
import { Activity, DollarSign, Wrench, UserPlus } from 'lucide-react';

const recentActivity = [
  { id: 1, type: 'payment', text: 'Pago recibido - Carlos Méndez', detail: '$3,500 - Cuota mensual', time: '10 min ago', icon: DollarSign, color: 'text-green-500' },
  { id: 2, type: 'order', text: 'Nueva orden de trabajo', detail: 'Reparación de fugas - Torre B', time: '25 min ago', icon: Wrench, color: 'text-orange-500' },
  { id: 3, type: 'access', text: 'Acceso con QR', detail: 'Visitante: Juan Pérez', time: '1 hora ago', icon: UserPlus, color: 'text-blue-500' },
  { id: 4, type: 'reservation', text: 'Nueva reserva', detail: 'Salón de eventos - Torre A 302', time: '2 horas ago', icon: Activity, color: 'text-purple-500' },
];

export function ActivityWidget() {
  return (
    <div className="space-y-0">
      {recentActivity.map((activity, index) => {
        const Icon = activity.icon;
        return (
          <div
            key={activity.id}
            className={`flex items-start gap-3 py-3 ${
              index !== recentActivity.length - 1 ? 'border-b border-gray-100' : ''
            }`}
          >
            <div className={`mt-0.5 ${activity.color}`}>
              <Icon className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900">{activity.text}</p>
              <p className="text-xs text-gray-500">{activity.detail}</p>
            </div>
            <span className="text-xs text-gray-400 flex-shrink-0">{activity.time}</span>
          </div>
        );
      })}

      <button className="w-full mt-3 py-2 text-sm font-medium text-[#36CCD8] hover:text-[#2DB8C4] hover:bg-[#36CCD8]/5 rounded-lg transition-colors">
        Ver historial completo →
      </button>
    </div>
  );
}

export default ActivityWidget;
